import React, { useState, useEffect, useRef, useContext } from 'react';
import { coreAxios } from "utilities/axios";
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Rating } from 'primereact/rating';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { FiEdit } from "react-icons/fi";
import { CommonButton } from "components/Buttons/Buttons";
import { MasterButton } from "components/Buttons/MasterButton";
import  DeleteModalTwo  from "components/Modal/DeleteModalTwo";


//NEW
import AuthContext from  "../../context/AuthContext";
import { InputField } from "components/InputField/Input";
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { GetRequisitions, AddRequisition, UpdateRequisition, DeleteRequisition, GetRequisitionItems, DeleteRequisitionItem } from 'services/requisition/requisition.service';
import { GetRequisitionTypes, GetSupplierNames } from 'services/dropdown/dropdown.service';
import { GetProductNames } from 'services/dropdown/dropdown.service';
import { RequisitionTableForm } from 'components/Table/RequisitionTableForm';
import { RequisitionRowExpansionTable } from 'components/Table/RowExpansionTable/RequisitionRowExpansionTable';
import { NameColumn, TextColumn, UrgentNormalStatusColumn, CompleteStatusColumn } from 'components/Table/ColumnTemplates/CustomColumn';
import { RequisitionValidationSchema } from 'utilities/ValidationSchema/Requisition/RequisitionValidationSchema';
import useProductDataTable from './hook/useProductDataTable';
const BASE_URL = process.env.REACT_APP_MAIN_URL


const Requisition = () => {

    const { requisitionList, requisitionListLoading } = useSelector((state) => state.requisitionList);
    const { requisitionAdd, requisitionAddLoading } = useSelector((state) => state.requisitionAdd);
    const { requisitionUpdate, supplierUpdateLoading } = useSelector((state) => state.requisitionUpdate);
    const { requisitionItems, requisitionItemsLoading } = useSelector((state) => state.requisitionItems);

    const [autoRequisitionTypeFilteredValue, setAutoRequisitionTypeFilteredValue] = useState([]);
    const [autoSupplierNameFilteredValue, setAutoSupplierNameFilteredValue] = useState([]);
    const [deleteProductID, setDeleteProductID] = useState();
    const [showDeleteProductModal, setShowDeleteProductModal] = useState(false);
    const [date, setDate] =useState(new Date());



    const { requisitionTypeList } = useSelector((state) => state.requisitionTypes);
    const { supplierNameList } = useSelector((state) => state.supplierNames);
    const { productNameList, productNameLoading } = useSelector((state) => state.productNames);


    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data
    const { user } = useContext(AuthContext);


    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        shop: user?.shop_id,
        requisition_type: "",
        requisition_date: date,
        supplier: "",
        remark: "",
        requisition_items: [
            {
                id: 0,
                product: "",
                stock_quantity: "",
                order_quantity: "",
                remark: "",
            },
        ],
    };

    const updateInitialValue = {
        id: updateData?.id,
        requisition_type: requisitionTypeList?.find((value) => value.id === updateData?.requisition_type) || "",
        requisition_date: new Date(updateData?.requisition_date),
        supplier: supplierNameList?.find((value) => value.id === updateData?.supplier) || "",
        remark: updateData?.remark,
        requisition_items: requisitionItems?.map((value) => {
            return {
                ...value,
                product: productNameList?.find((item) => item.id === value.product),
            };
        }) || [
            {
                id: 0,
                product: "",
                stock_quantity: 0,
                order_quantity: 0,
                remark: "",
            },
        ],

    };

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue, // * if state is update then updateData state value will show up
        validationSchema: RequisitionValidationSchema, // * yup schema validation
        onSubmit: (values) => {

            const modifiedData = {
                ...values,
                requisition_type: values?.requisition_type?.id || 0,
                supplier: values?.supplier?.id || 0,
                requisition_items: values.requisition_items.map((value) => {
                    return{
                        ...value,
                        product: value.product?.id,
                        stock_quantity: value.product?.stock_quantity,
                    }
                })
            };
            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const { modalTableColumns, modalTableActionButton } = useProductDataTable(
        formik, 
        setDeleteProductID, 
        setShowDeleteProductModal, 
        setShowForm, 
        setUpdateData,
    );


    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();


    const updateRequisition = (requisition) => {
        setShowForm(true); // * set the form to true
        dispatch(GetRequisitionItems(requisition?.id))
        setUpdateData(requisition);
    };

    // delete 1
    const toast = useRef(null);

    const DeleteModal =  (event, id) => {

        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteRequisition(id))
                await toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
                await dispatch(GetRequisitions());
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    const confirmDeleteProductDetail = async () => {
        const { id, requisition } = deleteProductID;
        await dispatch(DeleteRequisitionItem(id));
        setShowDeleteProductModal(false);
        await dispatch(GetRequisitionItems(requisition));
    };

    // form submit handler
    const handelSubmit = async (data) => {

        if(updateData){
            await dispatch(UpdateRequisition(data)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(AddRequisition(data)).then(() => {
            hideModal();
            return
        });
    };


    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(GetRequisitions());
        dispatch(GetRequisitionTypes());
        dispatch(GetSupplierNames());
        dispatch(GetProductNames());
        // const intervalId = setInterval(() => {
        //     setDate(new Date());
        //   }, 1000);
      
        //   return () => clearInterval(intervalId);
    }, [requisitionAdd, requisitionUpdate]);


    // columns of the table with header name
    const tableColumns = [
        { field: "name", header: "No.", sortableBody: NameColumn },
        { field: "requisition_type_name", header: "Requisition Type", sortableBody: UrgentNormalStatusColumn },
        { field: "date", header: "Requisition Date", sortableBody: TextColumn },
        { field: "shop_name", header: "Shop", sortableBody: TextColumn },
        { field: "supplier_name", header: "Supplier", sortableBody: TextColumn },
        { field: "work_order_status", header: "Work Order Status", sortableBody: CompleteStatusColumn },
        { field: "remark", header: "Remark", sortableBody: TextColumn },
    ];

    const searchRequsitionType = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && requisitionTypeList !== undefined) {
                setAutoRequisitionTypeFilteredValue([...requisitionTypeList]);
            } else {
                setAutoRequisitionTypeFilteredValue(
                    requisitionTypeList?.filter((requisition_type) => {
                        return requisition_type.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchSupplierName = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && supplierNameList !== undefined) {
                setAutoSupplierNameFilteredValue([...supplierNameList]);
            } else {
                setAutoSupplierNameFilteredValue(
                    supplierNameList?.filter((supplier) => {
                        return supplier.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };


    const downloadRequisition = async (rowData) => {
        const url = `${BASE_URL}/api/requisition/download/${rowData.id}/`;
        try {
            const response = await coreAxios.get(url, {
              responseType: 'blob',
            });
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `requisition-${rowData.name}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch(error){
          console.log(error)
        }
    };


    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "requisition_type",
            name: "requisition_type",
            type: "select",
            labelFor: "Requisition type",
            label: "Select Requisition type",
            required: true,
            className: "col-12 md:col-3",
            autoFilteredValue: autoRequisitionTypeFilteredValue,
            autoCompleteMethod: searchRequsitionType,
            selectedAutoValue: requisitionTypeList,
        },
        {
            id: "requisition_date",
            name: "requisition_date",
            value: "requisition_date",
            type: "date",
            labelFor: "Requisition Date",
            label: "Requisition Date",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-3",
        },
        {
            id: "supplier",
            name: "supplier",
            type: "select",
            labelFor: "Supplier",
            label: "Select Supplier",
            required: true,
            className: "col-12 md:col-3",
            autoFilteredValue: autoSupplierNameFilteredValue,
            autoCompleteMethod: searchSupplierName,
            selectedAutoValue: supplierNameList,
        },
        {
            id: "remark",
            name: "remark",
            value: "remark",
            type: "text",
            labelFor: "Remark",
            label: "Remark",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-3",
        },
    ];

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {
                        user.user_type === 'ADMIN' ? 
                        <>
                            <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => updateRequisition(rowData)} />
                            <Toast ref={toast} />
                            <ConfirmPopup />
                            <Button 
                                onClick={(e) => {
                                    DeleteModal(e, rowData.id);
                                }} 
                                icon="pi pi-trash" 
                                className="p-button-rounded p-button-warning mr-2"
                                disabled= {rowData.work_order_status === true ? true : false}
                            />
                        </> : <></>
                    }
                    <Button 
                        icon="pi pi-download" 
                        className="p-button-rounded p-button-secondary" 
                        onClick={(e) => {
                            downloadRequisition(rowData)
                        }}
                    />
                </div>
            </>
        );
    }

    return (
        <>
            <RequisitionRowExpansionTable
                //data
                tableHeaderName="Requisition Details"
                tableColumns={tableColumns}
                data={requisitionList}
                loading={requisitionListLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable
                exportBtn
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
            <Dialog 
                visible={showForm} 
                style={{ width: "1400px" }} 
                header={`${updateData ? "Update" : "Create"} Requisition`} 
                className="p-fluid" 
                onHide={hideModal} 
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                <form onSubmit={formik.handleSubmit} className={`grid grid-cols-4 mt-2 gap-x-3`}>
                    {inputData.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (
                            
                        <div key={id} className={`p-field ${className}`} >
                            <InputField
                                id={id}
                                type={type}
                                required={required}
                                name={name}
                                errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                                label={label}
                                labelFor={labelFor}
                                rows={rows}
                                value={formik.values[name]}
                                autoCompleteMethod={autoCompleteMethod}
                                autoFilteredValue={autoFilteredValue}
                                onChange={(...args) => {
                                    !onChange && formik.handleChange(...args);
                                    onChange?.(...args);
                                }}
                                onBlur={onBlur}
                                onClose={() => formik.setErrors({})}
                                {...rest}
                            />
                        </div>
                    ))}

                    <div className="col-12">
                        <div className="w-full">
                            <RequisitionTableForm
                                emptyMessage="No data found"
                                tableColumns={modalTableColumns}
                                data={formik.values.requisition_items}
                                loading={productNameLoading}
                                dataKey="productID"
                                actionButtonWidth={10}
                                actionButton={modalTableActionButton}
                            />
                        </div>
                    </div>
                    
                    <MasterButton resetForm={resetForm} update={updateData} loading={productNameLoading} col1={8} col2={updateData ? 6 : 7} col3={4}/>
                    <DeleteModalTwo
                        visibleModal={showDeleteProductModal}
                        header="Confirm"
                        onHide={() => setShowDeleteProductModal(false)}
                        multiItem={false}
                        confirmDelete={confirmDeleteProductDetail}
                        item={deleteProductID}
                        loading={requisitionItemsLoading}
                        message="Are you sure you want to delete this item? This Cannot be undone!"
                    />
                </form>
            </Dialog>
        </>
    );
};

export default Requisition;
